import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import Hero from "./sections/Hero";
import PrehledSluzeb from "./sections/PrehledSluzeb";
import WhyChooseUs from "./sections/WhyChooseUs";
import Reference from "./sections/Reference";
import KontaktAVypocetZdarma from "./sections/KontaktAVypocetZdarma";
export default function HomePage() {
  return <>
      <Header />
      <main>
        <Hero />
        <PrehledSluzeb />
        <WhyChooseUs />
        <Reference />
        <KontaktAVypocetZdarma />
      </main>
      <Footer />
    </>;
}